import {
  FilterField,
  FieldType,
  FilterOperator,
  TextOperator,
  NumberOperator,
  DateOperator,
  BooleanOperator,
  FilterRow,
  FilterLogic,
  ActiveFilterChip,
} from "@/types/filters";

// Field definitions for Stock Items
export const STOCK_ITEMS_TEXT_FIELDS: FilterField[] = [
  { id: "code", label: "Code", type: "text" },
  { id: "description", label: "Description", type: "text" },
  { id: "category", label: "Category", type: "text" },
  { id: "barcode", label: "Barcode", type: "text" },
  { id: "binNumber", label: "Bin Number", type: "text" },
  { id: "abcClassification", label: "ABC Classification", type: "text" },
  { id: "supplier", label: "Supplier", type: "text" },
];

export const STOCK_ITEMS_SELECT_FIELDS: FilterField[] = [
  { 
    id: "location", 
    label: "Location", 
    type: "select",
    options: [
      { value: "Single", label: "Single" },
      { value: "Multiple", label: "Multiple" }
    ]
  },
];

export const STOCK_ITEMS_NUMBER_FIELDS: FilterField[] = [
  { id: "physicalQuantity", label: "Physical Quantity", type: "number" },
  { id: "allocatedQuantity", label: "Allocated Quantity", type: "number" },
  { id: "freeQuantity", label: "Free Quantity", type: "number" },
  { id: "unitPrice", label: "Unit Price", type: "number" },
  { id: "value", label: "Value", type: "number" },
  { id: "totalCostOfSales", label: "Total Cost of Sales", type: "number" },
  { id: "totalValueOfSales", label: "Total Value of Sales", type: "number" },
  { id: "weight", label: "Weight", type: "number" },
  { id: "minQuantity", label: "Min Quantity", type: "number" },
  { id: "maxQuantity", label: "Max Quantity", type: "number" },
  { id: "stockTurnRate", label: "Stock Turn Rate", type: "number" },
  { id: "leadTimeDays", label: "Lead Time Days", type: "number" },
];

export const STOCK_ITEMS_DATE_FIELDS: FilterField[] = [
  { id: "lastPurchaseDate", label: "Last Purchase Date", type: "date" },
  { id: "lastSaleDate", label: "Last Sale Date", type: "date" },
  { id: "lastMovementDate", label: "Last Movement Date", type: "date" },
];

export const STOCK_ITEMS_BOOLEAN_FIELDS: FilterField[] = [
  { id: "inactive", label: "Inactive", type: "boolean" },
  { id: "isBelowReorderPoint", label: "Below Reorder Point", type: "boolean" },
];

// Field definitions for Stock Movements
export const STOCK_MOVEMENTS_TEXT_FIELDS: FilterField[] = [
  { id: "reference", label: "Reference", type: "text" },
  { id: "type", label: "Type", type: "text" },
  { id: "source", label: "Source", type: "text" },
  { id: "stockCode", label: "Stock Code", type: "text" },
  { id: "stockDescription", label: "Description", type: "text" },
  { id: "location", label: "Location", type: "text" },
  { id: "userName", label: "User", type: "text" },
  { id: "notes", label: "Notes", type: "text" },
];

export const STOCK_MOVEMENTS_NUMBER_FIELDS: FilterField[] = [
  { id: "quantity", label: "Quantity", type: "number" },
  { id: "unitPrice", label: "Unit Price", type: "number" },
  { id: "lineTotal", label: "Total Value", type: "number" },
];

export const STOCK_MOVEMENTS_DATE_FIELDS: FilterField[] = [
  { id: "date", label: "Date", type: "date" },
];

// Field definitions for Purchase Orders
export const PURCHASE_ORDERS_TEXT_FIELDS: FilterField[] = [
  { id: "poNumber", label: "PO Number", type: "text" },
  { id: "supplierCode", label: "Supplier Code", type: "text" },
  { id: "supplierName", label: "Supplier Name", type: "text" },
  { id: "status", label: "Status", type: "text" },
  { id: "projectCode", label: "Project Code", type: "text" },
  { id: "projectName", label: "Project Name", type: "text" },
  { id: "createdBy", label: "Created By", type: "text" },
  { id: "approvedBy", label: "Approved By", type: "text" },
  { id: "paymentTerms", label: "Payment Terms", type: "text" },
  { id: "currency", label: "Currency", type: "text" },
];

export const PURCHASE_ORDERS_NUMBER_FIELDS: FilterField[] = [
  { id: "totalValue", label: "Total Value", type: "number" },
  { id: "lineCount", label: "Number of Lines", type: "number" },
  { id: "fulfillmentPercentage", label: "Fulfillment %", type: "number" },
];

export const PURCHASE_ORDERS_DATE_FIELDS: FilterField[] = [
  { id: "orderDate", label: "Order Date", type: "date" },
  { id: "expectedDeliveryDate", label: "Expected Delivery Date", type: "date" },
  { id: "lastSyncDate", label: "Last Sync Date", type: "date" },
];

export const PURCHASE_ORDERS_BOOLEAN_FIELDS: FilterField[] = [
  { id: "isOverdue", label: "Is Overdue", type: "boolean" },
  { id: "hasOutstanding", label: "Has Outstanding Items", type: "boolean" },
];

// Field definitions for Locations (Warehouses & Locations screen)
export const LOCATIONS_TEXT_FIELDS: FilterField[] = [
  { id: "locationCode", label: "Location Code", type: "text" },
  { id: "locationType", label: "Type", type: "text" },
  { id: "aisle", label: "Aisle", type: "text" },
  { id: "rack", label: "Rack", type: "text" },
  { id: "shelf", label: "Shelf", type: "text" },
  { id: "bin", label: "Bin", type: "text" },
  { id: "notes", label: "Notes", type: "text" },
];

export const LOCATIONS_SELECT_FIELDS: FilterField[] = [
  {
    id: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "Active", label: "Active" },
      { value: "Blocked", label: "Blocked" },
      { value: "Inactive", label: "Inactive" },
    ],
  },
];

export const LOCATIONS_NUMBER_FIELDS: FilterField[] = [
  { id: "currentStock", label: "Current Stock", type: "number" },
  { id: "pickingSequence", label: "Picking Sequence", type: "number" },
];

export const LOCATIONS_DATE_FIELDS: FilterField[] = [
  { id: "lastActivity", label: "Last Activity", type: "date" },
];

// Legacy exports for backward compatibility (Stock Items)
export const TEXT_FIELDS = STOCK_ITEMS_TEXT_FIELDS;
export const NUMBER_FIELDS = STOCK_ITEMS_NUMBER_FIELDS;
export const DATE_FIELDS = STOCK_ITEMS_DATE_FIELDS;
export const BOOLEAN_FIELDS = STOCK_ITEMS_BOOLEAN_FIELDS;

export const ALL_FIELDS: FilterField[] = [
  ...STOCK_ITEMS_TEXT_FIELDS,
  ...STOCK_ITEMS_SELECT_FIELDS,
  ...STOCK_ITEMS_NUMBER_FIELDS,
  ...STOCK_ITEMS_DATE_FIELDS,
  ...STOCK_ITEMS_BOOLEAN_FIELDS,
];

// Get fields for specific entity type
export function getFieldsForEntity(entityType?: string): FilterField[] {
  switch (entityType) {
    case "stockMovements":
      return [
        ...STOCK_MOVEMENTS_TEXT_FIELDS,
        ...STOCK_MOVEMENTS_NUMBER_FIELDS,
        ...STOCK_MOVEMENTS_DATE_FIELDS,
      ];
    case "purchaseOrders":
      return [
        ...PURCHASE_ORDERS_TEXT_FIELDS,
        ...PURCHASE_ORDERS_NUMBER_FIELDS,
        ...PURCHASE_ORDERS_DATE_FIELDS,
        ...PURCHASE_ORDERS_BOOLEAN_FIELDS,
      ];
    case "locations":
      return [
        ...LOCATIONS_TEXT_FIELDS,
        ...LOCATIONS_SELECT_FIELDS,
        ...LOCATIONS_NUMBER_FIELDS,
        ...LOCATIONS_DATE_FIELDS,
      ];
    case "stockItems":
    default:
      return ALL_FIELDS;
  }
}

// Operator options
export interface OperatorOption {
  value: FilterOperator;
  label: string;
}

export const TEXT_OPERATORS: OperatorOption[] = [
  { value: "equals", label: "Equals" },
  { value: "notEquals", label: "Not equals" },
  { value: "contains", label: "Contains" },
  { value: "doesNotContain", label: "Does not contain" },
  { value: "startsWith", label: "Starts with" },
  { value: "endsWith", label: "Ends with" },
  { value: "isEmpty", label: "Is empty" },
  { value: "isNotEmpty", label: "Is not empty" },
];

export const NUMBER_OPERATORS: OperatorOption[] = [
  { value: "equals", label: "Equals" },
  { value: "notEquals", label: "Not equals" },
  { value: "greaterThan", label: "Greater than" },
  { value: "greaterThanOrEqual", label: "Greater than or equal" },
  { value: "lessThan", label: "Less than" },
  { value: "lessThanOrEqual", label: "Less than or equal" },
  { value: "between", label: "Between" },
  { value: "isEmpty", label: "Is empty" },
  { value: "isNotEmpty", label: "Is not empty" },
];

export const DATE_OPERATORS: OperatorOption[] = [
  { value: "equals", label: "Equals" },
  { value: "before", label: "Before" },
  { value: "after", label: "After" },
  { value: "between", label: "Between" },
  { value: "inLastXDays", label: "In last X days" },
  { value: "isEmpty", label: "Is empty" },
  { value: "isNotEmpty", label: "Is not empty" },
];

export const BOOLEAN_OPERATORS: OperatorOption[] = [
  { value: "isYes", label: "Is Yes" },
  { value: "isNo", label: "Is No" },
];

export const SELECT_OPERATORS: OperatorOption[] = [
  { value: "equals", label: "Equals" },
  { value: "notEquals", label: "Not Equals" },
];

// Helper functions
export function getFieldType(fieldId: string, fields?: FilterField[]): FieldType | null {
  const searchFields = fields || ALL_FIELDS;
  const field = searchFields.find((f) => f.id === fieldId);
  return field ? field.type : null;
}

export function getFieldLabel(fieldId: string): string {
  const field = ALL_FIELDS.find((f) => f.id === fieldId);
  return field ? field.label : fieldId;
}

export function getOperatorsForFieldType(fieldType: FieldType): OperatorOption[] {
  switch (fieldType) {
    case "text":
      return TEXT_OPERATORS;
    case "number":
      return NUMBER_OPERATORS;
    case "date":
      return DATE_OPERATORS;
    case "boolean":
      return BOOLEAN_OPERATORS;
    case "select":
      return SELECT_OPERATORS;
    default:
      return [];
  }
}

export function getOperatorLabel(operator: FilterOperator): string {
  const allOperators = [
    ...TEXT_OPERATORS,
    ...NUMBER_OPERATORS,
    ...DATE_OPERATORS,
    ...BOOLEAN_OPERATORS,
    ...SELECT_OPERATORS,
  ];
  const op = allOperators.find((o) => o.value === operator);
  return op ? op.label : operator;
}

export function operatorRequiresValue(operator: FilterOperator): boolean {
  return !["isEmpty", "isNotEmpty", "isYes", "isNo"].includes(operator);
}

export function operatorRequiresTwoValues(operator: FilterOperator): boolean {
  return operator === "between";
}

// Generate filter summary text
export function generateFilterSummary(
  rows: FilterRow[],
  logic: FilterLogic[]
): string {
  if (rows.length === 0) return "";

  const parts: string[] = [];

  rows.forEach((row, index) => {
    const fieldLabel = getFieldLabel(row.field);
    const operatorLabel = getOperatorLabel(row.operator).toLowerCase();
    
    let valuePart = "";
    if (operatorRequiresValue(row.operator)) {
      if (operatorRequiresTwoValues(row.operator)) {
        valuePart = ` ${formatValue(row.value)} and ${formatValue(row.value2)}`;
      } else if (row.operator === "inLastXDays") {
        valuePart = ` ${row.value} days`;
      } else {
        valuePart = ` ${formatValue(row.value)}`;
      }
    }

    parts.push(`${fieldLabel} ${operatorLabel}${valuePart}`);

    if (index < rows.length - 1 && logic[index]) {
      parts.push(` ${logic[index]} `);
    }
  });

  return `Show items where ${parts.join("")}`;
}

function formatValue(value: string | number | Date | null | undefined): string {
  if (value === null || value === undefined) return "";
  if (value instanceof Date) {
    return value.toLocaleDateString("en-GB");
  }
  return String(value);
}

// Generate active filter chips
export function generateFilterChips(
  rows: FilterRow[],
  logic: FilterLogic[]
): ActiveFilterChip[] {
  return rows.map((row, index) => {
    const fieldLabel = getFieldLabel(row.field);
    const operatorLabel = getOperatorLabel(row.operator);
    
    let displayText = `${fieldLabel} ${operatorLabel}`;
    
    if (operatorRequiresValue(row.operator)) {
      if (operatorRequiresTwoValues(row.operator)) {
        displayText += ` ${formatValue(row.value)} - ${formatValue(row.value2)}`;
      } else if (row.operator === "inLastXDays") {
        displayText += ` ${row.value} days`;
      } else {
        displayText += ` ${formatValue(row.value)}`;
      }
    }

    return {
      id: row.id,
      field: row.field,
      operator: row.operator,
      value: row.value,
      value2: row.value2,
      displayText,
    };
  });
}

// Validate filter row
export function validateFilterRow(row: FilterRow): string | null {
  if (!row.field) {
    return "Please select a field";
  }

  if (!row.operator) {
    return "Please select an operator";
  }

  if (operatorRequiresValue(row.operator)) {
    if (row.value === null || row.value === undefined || row.value === "") {
      return "Please enter a value";
    }

    if (operatorRequiresTwoValues(row.operator)) {
      if (row.value2 === null || row.value2 === undefined || row.value2 === "") {
        return "Please enter a second value";
      }

      // For number fields, validate range
      const fieldType = getFieldType(row.field);
      if (fieldType === "number") {
        const val1 = Number(row.value);
        const val2 = Number(row.value2);
        if (val1 >= val2) {
          return "First value must be less than second value";
        }
      }

      // For date fields, validate range
      if (fieldType === "date") {
        const date1 = row.value instanceof Date ? row.value : new Date(row.value);
        const date2 = row.value2 instanceof Date ? row.value2 : new Date(row.value2);
        if (date1 >= date2) {
          return "Start date must be before end date";
        }
      }
    }
  }

  return null;
}

// Apply filters to data
export function applyFilters<T extends Record<string, any>>(
  data: T[],
  rows: FilterRow[],
  logic: FilterLogic[]
): T[] {
  if (rows.length === 0) return data;

  return data.filter((item) => {
    let result = evaluateFilterRow(item, rows[0]);

    for (let i = 1; i < rows.length; i++) {
      const rowResult = evaluateFilterRow(item, rows[i]);
      const logicOperator = logic[i - 1] || "AND";

      if (logicOperator === "AND") {
        result = result && rowResult;
      } else {
        result = result || rowResult;
      }
    }

    return result;
  });
}

function evaluateFilterRow<T extends Record<string, any>>(
  item: T,
  row: FilterRow
): boolean {
  // Handle computed fields
  let fieldValue = item[row.field];
  
  // Special handling for computed boolean fields
  if (row.field === "isBelowReorderPoint") {
    // Check if physical quantity is at or below reorder point
    fieldValue = item.physicalQuantity <= item.reorderPoint;
  }
  
  // Special handling for location field - convert to "Single" or "Multiple"
  if (row.field === "location") {
    const hasMultipleLocations = item.locationQuantities && item.locationQuantities.length > 1;
    fieldValue = hasMultipleLocations ? "Multiple" : "Single";
  }
  
  const fieldType = getFieldType(row.field);

  if (!fieldType) return true;

  switch (fieldType) {
    case "text":
      return evaluateTextFilter(fieldValue, row.operator as TextOperator, row.value);
    case "number":
      return evaluateNumberFilter(fieldValue, row.operator as NumberOperator, row.value, row.value2);
    case "date":
      return evaluateDateFilter(fieldValue, row.operator as DateOperator, row.value, row.value2);
    case "boolean":
      return evaluateBooleanFilter(fieldValue, row.operator as BooleanOperator);
    default:
      return true;
  }
}

function evaluateTextFilter(
  fieldValue: any,
  operator: TextOperator,
  value: string | number | Date | null
): boolean {
  const strValue = String(fieldValue || "").toLowerCase();
  const compareValue = String(value || "").toLowerCase();

  switch (operator) {
    case "equals":
      return strValue === compareValue;
    case "notEquals":
      return strValue !== compareValue;
    case "contains":
      return strValue.includes(compareValue);
    case "doesNotContain":
      return !strValue.includes(compareValue);
    case "startsWith":
      return strValue.startsWith(compareValue);
    case "endsWith":
      return strValue.endsWith(compareValue);
    case "isEmpty":
      return !fieldValue || strValue === "";
    case "isNotEmpty":
      return !!fieldValue && strValue !== "";
    default:
      return true;
  }
}

function evaluateNumberFilter(
  fieldValue: any,
  operator: NumberOperator,
  value: string | number | Date | null,
  value2?: string | number | Date | null
): boolean {
  const numValue = Number(fieldValue);
  const compareValue = Number(value);
  const compareValue2 = Number(value2);

  if (operator === "isEmpty") {
    return fieldValue === null || fieldValue === undefined;
  }

  if (operator === "isNotEmpty") {
    return fieldValue !== null && fieldValue !== undefined;
  }

  if (isNaN(numValue)) return false;

  switch (operator) {
    case "equals":
      return numValue === compareValue;
    case "notEquals":
      return numValue !== compareValue;
    case "greaterThan":
      return numValue > compareValue;
    case "greaterThanOrEqual":
      return numValue >= compareValue;
    case "lessThan":
      return numValue < compareValue;
    case "lessThanOrEqual":
      return numValue <= compareValue;
    case "between":
      return numValue >= compareValue && numValue <= compareValue2;
    default:
      return true;
  }
}

function evaluateDateFilter(
  fieldValue: any,
  operator: DateOperator,
  value: string | number | Date | null,
  value2?: string | number | Date | null
): boolean {
  if (operator === "isEmpty") {
    return fieldValue === null || fieldValue === undefined;
  }

  if (operator === "isNotEmpty") {
    return fieldValue !== null && fieldValue !== undefined;
  }

  if (!fieldValue) return false;

  const dateValue = fieldValue instanceof Date ? fieldValue : new Date(fieldValue);
  const compareDate = value instanceof Date ? value : new Date(value!);
  const compareDate2 = value2 instanceof Date ? value2 : new Date(value2!);

  // Reset time parts for date comparison
  dateValue.setHours(0, 0, 0, 0);
  compareDate.setHours(0, 0, 0, 0);
  if (value2) compareDate2.setHours(0, 0, 0, 0);

  switch (operator) {
    case "equals":
      return dateValue.getTime() === compareDate.getTime();
    case "before":
      return dateValue.getTime() < compareDate.getTime();
    case "after":
      return dateValue.getTime() > compareDate.getTime();
    case "between":
      return dateValue.getTime() >= compareDate.getTime() && dateValue.getTime() <= compareDate2.getTime();
    case "inLastXDays":
      const daysAgo = Number(value);
      const cutoffDate = new Date();
      cutoffDate.setDate(cutoffDate.getDate() - daysAgo);
      cutoffDate.setHours(0, 0, 0, 0);
      return dateValue.getTime() >= cutoffDate.getTime();
    default:
      return true;
  }
}

function evaluateBooleanFilter(
  fieldValue: any,
  operator: BooleanOperator
): boolean {
  const boolValue = Boolean(fieldValue);

  switch (operator) {
    case "isYes":
      return boolValue === true;
    case "isNo":
      return boolValue === false;
    default:
      return true;
  }
}
